import { render } from "./EntriesPerPage.vue?vue&type=template&id=570338be&scoped=true"
import script from "./EntriesPerPage.vue?vue&type=script&lang=js"
export * from "./EntriesPerPage.vue?vue&type=script&lang=js"

import "./EntriesPerPage.vue?vue&type=style&index=0&id=570338be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570338be"]])

export default __exports__